import styled, { createGlobalStyle } from "styled-components";

import {
  DEFAULT_FONT,
  DEFAULT_OFFSET,
  fontSizes,
  fontWeights,
  MOBILE_BREAKPOINT,
} from "@util/constants";

export const GlobalStyle = createGlobalStyle`

  html {
    opacity: 0;
    transition: opacity 0.1s ease;
  }

  html.has-mounted {
    opacity: 1;
  }
  
  body {
    margin: 0px;
    font-size: ${fontSizes.p.default}px;
    font-weight: ${fontWeights.normal};
    color: var(--theme-text-color, var(--theme-primary-color));
    background-color: white;
    letter-spacing: 0.01em;
    font-family: var(--theme-font);
    white-space: normal;
    text-rendering: auto;
    background-color: var(--theme-site-bg);
  }
  h1 {
    font-size: ${fontSizes.h1.default}px;
    font-weight: ${fontWeights.mid};
    font-family: var(--theme-font-header);
    line-height: var(--theme-heading-line-height);
    letter-spacing: var(--theme-header-letter-spacing);
    font-feature-settings: var(--theme-font-feature-settings);
  }
  h2 {
    font-size: ${fontSizes.h2.default}px;
    font-weight: ${fontWeights.mid};
    font-family: var(--theme-font-sub-header);
    margin: 10px 0;
    line-height: var(--theme-heading-line-height);
    letter-spacing: var(--theme-header-letter-spacing);
    font-feature-settings: var(--theme-font-feature-settings)

  }
  h3 {
    font-size: ${fontSizes.h3.default}px;
    font-weight: 300;
    font-family: var(--theme-font-sub-header);
    margin: 10px 0;
    line-height: 120%;
    letter-spacing: var(--theme-header-letter-spacing);
  }
  h4 {
    font-size: ${fontSizes.h4.default}px;
    font-weight: ${fontWeights.bold};
    font-family: var(--theme-font-sub-header);
    margin: 0;
    line-height: 1.6;
  }

  strong {
    font-weight: ${fontWeights.bold};
  }

  button {
    font-size: ${fontSizes.button.default}px;
    font-family: var(--theme-font);
    cursor: pointer;
  }
  input, textarea, select{
    font-family: ${DEFAULT_FONT};
    &:active, &:focus{
      outline: none;
    }
  }

  p, li {
    line-height: 1.5;
  }

  a {
    user-select: none;
    text-decoration: none;
    white-space: normal;
    text-overflow: ellipsis;
    color: var(--theme-text-color, var(--theme-primary-color));
    line-height: 1.2;
    cursor: pointer;
    transition: 0.3s opacity ease;
    &:hover {
      opacity: 0.8;
      text-underline-offset: 3px;
      text-decoration: var(--theme-link-hover-decor);
      text-decoration-thickness: 1.5px;
    }
  }


  .card-width {
    width: 400px;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    body {
    font-size: ${fontSizes.p.mobile}px;
    }
    h1 {
      font-size: ${fontSizes.h1.mobile}px;
    }
    h2 {
      font-size: ${fontSizes.h2.mobile}px;
    }
    h3 {
      font-size: ${fontSizes.h3.mobile}px;
    }
    h4 {
      font-size: ${fontSizes.h4.mobile}px;
    }
    button {
      font-size: ${fontSizes.button.mobile}px;
    }

    .card-width {
      width: 100%;
    }

  }
  .Toastify__toast {
    background: var(--theme-primary-color);
    border-radius: 20px;
    font-family: ${DEFAULT_FONT};
  }
  .Toastify__toast-body{
    padding: 6px 13px;
  }

  .Toastify__toast--error {
    background: #e74c3c;
 }

 .imageLink{
    font-size: 0;
 }

 .btn {
  padding: 15px 30px;
  border-radius: 100px;
  white-space: nowrap;
 }

 .transparent {
    color: var(--theme-primary-color);
    border: 1px solid var(--theme-primary-color);
    background-color: transparent;
    &:hover {
      color: white;
      border: 1px solid var(--theme-primary-color);
      background-color: var(--theme-primary-color);
    }
  }

 .Accordion {
  border: none !important;
  border-bottom: 1px solid black !important;
  margin-bottom: 10px !important;
 }

 /* Font loading states */
 .fonts-loading {
   /* Prevent layout shifts during font loading */
   font-display: swap;
 }
 
 .fonts-loading * {
   /* Use system fonts as fallback during loading */
   font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif !important;
 }
 
 .fonts-loaded {
   /* Fonts are loaded, use custom fonts */
   transition: font-family 0.3s ease;
 }

`;

export const Main = styled.main<{}>`
  // padding-top: ${DEFAULT_OFFSET}px;
  overflow-x: hidden;
`;
